import BaseService from '../BaseService';

class StockService extends BaseService {
    getAll = (filters) => this.post('/warehouse/report/stock', filters || { });
}

export default new StockService();